"use strict";
/**
 * SearchInput
 *
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_i18next_1 = require("react-i18next");
var material_1 = require("@mui/material");
var Search_1 = __importDefault(require("@mui/icons-material/Search"));
var commonTypes_1 = require("../../types/commonTypes");
var crude_selector_1 = require("../../../store/crude/crude.selector");
var crudeActions = __importStar(require("../../../store/crude/crude.actions"));
var SearchComponent = function (props) {
    var _a, _b, _c;
    var t = react_i18next_1.useTranslation().t;
    var theme = material_1.useTheme();
    var dispatch = react_redux_1.useDispatch();
    var appLayout = react_redux_1.useSelector(crude_selector_1.getAppLayout);
    var dataDisplayMode = react_redux_1.useSelector(crude_selector_1.getDataDisplayMode);
    var storedTableFilterSettings = react_redux_1.useSelector(crude_selector_1.getTableFilterSettings);
    var entity = props.entity;
    var _d = react_1.useState((entity && ((_a = storedTableFilterSettings[entity][props.treeviewLevel]) === null || _a === void 0 ? void 0 : _a.search)) || ''), searchInput = _d[0], setSearchInput = _d[1];
    var disabled = (props.dataViewType && props.dataViewType === commonTypes_1.DataViewType.referenceView)
        ? false
        : (dataDisplayMode === commonTypes_1.DataDisplayMode.edit ? true : (props.disabled ? props.disabled : false));
    var _e = react_1.useState(), timer = _e[0], setTimer = _e[1];
    react_1.useEffect(function () {
        var _a;
        setSearchInput((_a = storedTableFilterSettings[entity][props.treeviewLevel]) === null || _a === void 0 ? void 0 : _a.search);
    }, [(_b = storedTableFilterSettings[entity][props.treeviewLevel]) === null || _b === void 0 ? void 0 : _b.search]);
    var sendChanging = function (value) {
        var _a, _b;
        if (entity) {
            var newSettings = __assign(__assign({}, (storedTableFilterSettings[entity][props.treeviewLevel || 0])), { search: value, page: 0 });
            var changeSettings = __assign(__assign({}, storedTableFilterSettings), (_a = {}, _a[entity] = (_b = {},
                _b[props.treeviewLevel || 0] = newSettings,
                _b), _a));
            dispatch(crudeActions.setShowCollapse(false));
            dispatch(crudeActions.setTableFilterSettings(changeSettings));
        }
    };
    return (react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
        react_1.default.createElement(material_1.TextField, { disabled: disabled, id: 'search', autoFocus: true, label: t('crude:search'), name: 'name', color: 'primary', autoComplete: 'off', sx: {
                width: props.width ? props.width : props.fullWidth ? '100%' : '300px',
                '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                    borderWidth: 2,
                },
            }, InputProps: {
                endAdornment: (react_1.default.createElement(material_1.InputAdornment, { position: 'end' },
                    react_1.default.createElement(Search_1.default, null))),
            }, InputLabelProps: {
                shrink: true,
            }, onChange: (function (event) {
                setSearchInput(event.target.value);
                if (event.target.value !== searchInput) {
                    if (timer) {
                        clearTimeout(timer);
                    }
                    setTimer(setTimeout(function () { return sendChanging(event.target.value); }, 400));
                }
            }), size: 'small', variant: (_c = appLayout.textfield) === null || _c === void 0 ? void 0 : _c.type, value: searchInput })));
};
exports.default = SearchComponent;
